module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "risk-container"
  }, [_c('div', {
    staticClass: "risk-header"
  }, [_c('el-button', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    staticStyle: {
      "margin-left": "10px",
      "display": "inline-block",
      "float": "right"
    },
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v("#单项Q值=（折纯量&最大存储量）/临界量  （有折纯用折纯，没有用最大存储量）")]), _vm._v(" "), _c('p', [_vm._v("#总Q值=sum（各单项Q值）")]), _vm._v(" "), _c('p', [_vm._v("#Q值计算保留2个小数位，四舍五入取整")]), _vm._v(" "), _c('p', [_vm._v("#国标中风险物质分类无法详尽描述，可选择多个主分类后，在【风险物质细分补充说明】进行说明，每一行仅一个子分类说明：如")]), _vm._v(" "), _c('p', [_vm._v("##国标第三部分 有毒液态物质 乙苯，可以选择3列，分别说明为")]), _vm._v(" "), _c('p', [_vm._v("【乙苯】、【油漆、稀释剂中的乙苯】、【胶黏剂(按乙苯极)】")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#409EFF",
      "cursor": "pointer"
    }
  }, [_vm._v("填写说明")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "risk-content"
  }, [(_vm.hasSubstanceType) ? _c('div', {
    staticClass: "grouped-table-container"
  }, _vm._l((_vm.groupedData), function(group, index) {
    return _c('el-card', {
      key: index,
      staticClass: "group-card"
    }, [(group.type) ? _c('template', {
      slot: "header"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatSubstanceType(group.type)))]), _vm._v(" "), _c('span', {
      staticClass: "q-value"
    }, [_vm._v("Q值合计: " + _vm._s(group.total.toFixed(2)))])])]) : _vm._e(), _vm._v(" "), _c('el-table', {
      attrs: {
        "data": group.items,
        "border": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "index"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "riskType",
        "label": "风险物质类型"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n              " + _vm._s(_vm.formatRiskType(scope.row.riskType)) + "\n            ")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "cas",
        "label": "CAS号"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "物质名称"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "riskName"
          }, [_c('span', [_vm._v(_vm._s(scope.row.name))]), _vm._v(" "), _c('i', {
            staticClass: "el-icon-edit",
            on: {
              "click": function($event) {
                _vm.modify(scope.row)
              }
            }
          })])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "criticalValue",
        "label": "临界量(吨)"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "state",
        "label": "形态"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n              " + _vm._s(_vm.formatState(scope.row.state)) + "\n            ")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "count",
        "label": "最大存储量(吨)"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "purity",
        "label": "折纯量(吨)"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "remark",
        "label": "补充说明"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "qValue",
        "label": "Q值"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "fixed": "right"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            attrs: {
              "size": "mini",
              "type": "danger",
              "icon": "delete"
            },
            on: {
              "click": function($event) {
                _vm.delectRisk(scope.row)
              }
            }
          })]
        }
      }])
    })], 1)], 2)
  })) : _c('div', {
    staticClass: "normal-table-container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "物质名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "riskName"
        }, [_c('span', [_vm._v(_vm._s(scope.row.name))]), _vm._v(" "), _c('i', {
          staticClass: "el-icon-edit",
          on: {
            "click": function($event) {
              _vm.modify(scope.row)
            }
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cas",
      "label": "CAS号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "形态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.formatState(scope.row.state)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "数量(吨)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purity",
      "label": "折纯量(吨)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "criticalValue",
      "label": "临界量(吨)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qValue",
      "label": "Q值"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "icon": "delete"
          },
          on: {
            "click": function($event) {
              _vm.delectRisk(scope.row)
            }
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加风险物质",
      "size": "small",
      "id": "dialogVisible"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "risk-left"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "搜索",
      "icon": "search",
      "size": "small",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_material_list($event)
      }
    },
    model: {
      value: (_vm.searchrisk),
      callback: function($$v) {
        _vm.searchrisk = $$v
      },
      expression: "searchrisk"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('ul', _vm._l((_vm.materialData), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        activeSel: _vm.matSelIndex === index
      },
      on: {
        "click": function($event) {
          _vm.handleSel(item, index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "risk-right"
  }, [_c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("物质：")]), _vm._v(" "), _c('span', {
    staticClass: "value",
    attrs: {
      "title": _vm.paramsModel.name
    }
  }, [_vm._v(_vm._s(_vm.paramsModel.name))])]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("CAS号：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.paramsModel.cas))])]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("临界量(吨)：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.paramsModel.criticalValue))])]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("形态：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.paramsModel.state),
      callback: function($$v) {
        _vm.$set(_vm.paramsModel, "state", $$v)
      },
      expression: "paramsModel.state"
    }
  }, _vm._l((_vm.stateOptions), function(item, i) {
    return _c('el-radio', {
      key: i,
      attrs: {
        "mini": "",
        "label": item.label
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("物质分类：")]), _vm._v(" "), _c('span', {
    staticClass: "value",
    staticStyle: {
      "width": "260px"
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.paramsModel.substanceType),
      callback: function($$v) {
        _vm.$set(_vm.paramsModel, "substanceType", $$v)
      },
      expression: "paramsModel.substanceType"
    }
  }, _vm._l((_vm.filteredSubstanceTypeOptions), function(item, i) {
    return _c('el-checkbox', {
      key: i,
      attrs: {
        "mini": "",
        "label": item.label
      }
    }, [_vm._v("\n                      " + _vm._s(item.name) + "\n                    ")])
  }))], 1), _vm._v(" "), (_vm.filteredSubstanceTypeOptions && _vm.filteredSubstanceTypeOptions.length === 2) ? _c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#DC143C",
      "margin-top": "5px"
    }
  }, [_vm._v("*如同时涉水、涉气，请同时勾选")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("数量(吨)：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "min": 0,
      "step": 0.01,
      "placeholder": "请填写最大储存量"
    },
    nativeOn: {
      "input": function($event) {
        return _vm.changeMaxCode($event)
      }
    },
    model: {
      value: (_vm.paramsModel.count),
      callback: function($$v) {
        _vm.$set(_vm.paramsModel, "count", $$v)
      },
      expression: "paramsModel.count"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("(填写最大储存量)")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("折纯量(吨)：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "min": 0,
      "step": 0.01
    },
    nativeOn: {
      "input": function($event) {
        return _vm.changePurity($event)
      }
    },
    model: {
      value: (_vm.paramsModel.purity),
      callback: function($$v) {
        _vm.$set(_vm.paramsModel, "purity", $$v)
      },
      expression: "paramsModel.purity"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 20
    },
    model: {
      value: (_vm.paramsModel.remark),
      callback: function($$v) {
        _vm.$set(_vm.paramsModel, "remark", $$v)
      },
      expression: "paramsModel.remark"
    }
  })], 1)])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitMt
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改风险物质",
      "size": "small",
      "id": "modifyVisible"
    },
    model: {
      value: (_vm.modifyVisible),
      callback: function($$v) {
        _vm.modifyVisible = $$v
      },
      expression: "modifyVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "risk-right riskmd",
    staticStyle: {
      "height": "auto",
      "min-height": "400px"
    }
  }, [_c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("物质：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.singleRisk.name))])]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("CAS号：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.singleRisk.cas))])]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("临界量：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.singleRisk.criticalValue))])]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("形态：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.singleRisk.state),
      callback: function($$v) {
        _vm.$set(_vm.singleRisk, "state", $$v)
      },
      expression: "singleRisk.state"
    }
  }, _vm._l((_vm.stateOptions), function(item, i) {
    return _c('el-radio', {
      key: i,
      attrs: {
        "mini": "",
        "label": item.label
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)]), _vm._v(" "), (_vm.singleRisk.substanceTypeListStr) ? [_c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("物质分类：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.singleRisk.substanceType),
      callback: function($$v) {
        _vm.$set(_vm.singleRisk, "substanceType", $$v)
      },
      expression: "singleRisk.substanceType"
    }
  }, _vm._l((_vm.filteredSubstanceTypeOptions), function(item, i) {
    return _c('el-checkbox', {
      key: i,
      attrs: {
        "mini": "",
        "label": item.label
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")])
  }))], 1)])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("数量：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "min": 0,
      "step": 0.01,
      "placeholder": "请填写最大储存量"
    },
    nativeOn: {
      "input": function($event) {
        return _vm.changeMaxCode($event)
      }
    },
    model: {
      value: (_vm.singleRisk.count),
      callback: function($$v) {
        _vm.$set(_vm.singleRisk, "count", $$v)
      },
      expression: "singleRisk.count"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("(填写最大储存量)")])], 1)]), _vm._v(" "), (_vm.singleRisk.substanceTypeListStr) ? [_c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("折纯量(吨)：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "min": 0,
      "step": 0.01
    },
    nativeOn: {
      "input": function($event) {
        return _vm.changePurity($event)
      }
    },
    model: {
      value: (_vm.singleRisk.purity),
      callback: function($$v) {
        _vm.$set(_vm.singleRisk, "purity", $$v)
      },
      expression: "singleRisk.purity"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tlt"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 20
    },
    model: {
      value: (_vm.singleRisk.remark),
      callback: function($$v) {
        _vm.$set(_vm.singleRisk, "remark", $$v)
      },
      expression: "singleRisk.remark"
    }
  })], 1)])] : _vm._e()], 2)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.modifyVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitSaveMT
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增物质",
      "visible": _vm.addnew,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addnew = $event
      }
    }
  }, [_c('el-form', {
    ref: "formlist",
    attrs: {
      "model": _vm.formlist,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物质"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formlist.name),
      callback: function($$v) {
        _vm.$set(_vm.formlist, "name", $$v)
      },
      expression: "formlist.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CAS号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formlist.cas),
      callback: function($$v) {
        _vm.$set(_vm.formlist, "cas", $$v)
      },
      expression: "formlist.cas"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "临界值(吨)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.formlist.criticalValue),
      callback: function($$v) {
        _vm.$set(_vm.formlist, "criticalValue", $$v)
      },
      expression: "formlist.criticalValue"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重点环境管理危险化学品"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formlist.serious),
      callback: function($$v) {
        _vm.$set(_vm.formlist, "serious", $$v)
      },
      expression: "formlist.serious"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "风险属性"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择风险属性"
    },
    on: {
      "change": _vm.changeType
    },
    model: {
      value: (_vm.formlist.riskType),
      callback: function($$v) {
        _vm.$set(_vm.formlist, "riskType", $$v)
      },
      expression: "formlist.riskType"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formlist.remark),
      callback: function($$v) {
        _vm.$set(_vm.formlist, "remark", $$v)
      },
      expression: "formlist.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addnew = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addnewsupply
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59526c85","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/burst/RiskMaterial.vue
// module id = 1231
// module chunks = 2